// Route: '/game/:gameid'
import React, { useContext, useEffect, useState } from 'react';
import Nav from '../../components/Nav/Nav';
import styles from './EditGamePage.module.css';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { StoreContext } from '../../utils/store';
import { BaseButton, PrimaryButton } from '../../components/Buttons/Buttons';
import QuestionCard from '../../components/QuestionCard/QuestionCard';
import { FiEdit } from 'react-icons/fi';
import Tooltip from '@material-ui/core/Tooltip';

const EditGamePage = () => {
  const { gameid } = useParams();
  const history = useHistory();
  const context = useContext(StoreContext);
  const [api] = context.api;
  const [, setModalStatus] = context.modalStatus;
  const [added, setAdded] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const [toEdit, setToEdit] = useState(false);
  const [name, setName] = useState('');
  const [quiz, setQuiz] = useState({
    id: 0,
    name: '',
    questions: [],
  })

  // api call functions
  const addQuestion = async () => {
    const newQuestions = [...quiz.questions];
    newQuestions.push({
      qString: '',
      type: 'Single',
      timeLimit: '0',
      point: '0',
      answers: ['', ''],
      mediaType: '',
      correctAnswers: [true, false, false, false, false, false],
      img: '',
      video: '',
    });
    const response = await api.makeAPIRequest(`admin/quiz/${gameid}`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify({
        questions: newQuestions,
        thumbnail: '',
      })
    });
    try {
      const json = await response.json();
      if (response.status === 200) {
        console.log('add a new question');
        console.log(quiz);
        setAdded(!added);
      } else {
        setModalStatus(status => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Error',
          modalBodyText: json.error,
          modalColors: 'error',
        }));
      }
    } catch (e) {
      console.log('ERROR', e);
      setModalStatus(status => ({
        ...status,
        modalActive: true,
        overlayActive: true,
        modalHeaderText: 'Error',
        modalBodyText: 'Sorry! Can\' connect to the server.',
        modalColors: 'error',
      }));
    }
  };
  const getGame = async () => {
    const response = await api.makeAPIRequest(`admin/quiz/${gameid}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    try {
      const json = await response.json();
      if (response.status === 200) {
        return json;
      } else {
        setModalStatus(status => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Error',
          modalBodyText: json.error,
          modalColors: 'error',
        }));
      }
    } catch (e) {
      console.log('ERROR', e);
      setModalStatus(status => ({
        ...status,
        modalActive: true,
        overlayActive: true,
        modalHeaderText: 'Error',
        modalBodyText: 'Sorry! Can\' connect to the server.',
        modalColors: 'error',
      }));
    }
  };

  const updateGameName = async () => {
    const response = await api.makeAPIRequest(`admin/quiz/${gameid}`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify({
        name,
      })
    });
    try {
      const json = await response.json();
      if (response.status === 200) {
        setToEdit(false);
      } else {
        setModalStatus(status => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Error',
          modalBodyText: json.error,
          modalColors: 'error',
        }));
      }
    } catch (e) {
      console.log('ERROR', e);
      setModalStatus(status => ({
        ...status,
        modalActive: true,
        overlayActive: true,
        modalHeaderText: 'Error',
        modalBodyText: 'Sorry! Can\' connect to the server.',
        modalColors: 'error',
      }));
    }
  };
  // set up quiz state
  useEffect(async () => {
    if (localStorage.getItem('token')) {
      const q = await getGame();
      setQuiz(q);
      setName(q.name);
      console.log(q);
    }
  }, [added, deleted, toEdit]);

  if (!localStorage.getItem('token')) {
    return (
      <Redirect to='/' />
    );
  } else {
    return (
      <>
        <Nav
          visibilities={['false', 'false', 'false', 'false', 'true']}
          confirm={() => history.push('/')}
        />
        <section className={styles.main}>
          <div className={styles.topBar}>
            {!toEdit
              ? <>
                <h3>
                  {quiz.name}
                  <Tooltip title="Edit game name">
                    <span className={styles.editIcon}>
                      <FiEdit
                        onClick={() => setToEdit(true)}
                      />
                    </span>
                  </Tooltip>
                </h3>
              </>
              : <div className={styles.inputContainer}>
                <input
                  className={styles.nameInput}
                  type='text'
                  value={name}
                  onChange={e => setName(e.target.value)}
                />
                <BaseButton
                  onClick={updateGameName}
                >
                  OK
                  </BaseButton>
              </div>
            }
            <PrimaryButton
              onClick={addQuestion}
            >Add a question</PrimaryButton>
          </div>
          <div className={styles.questionContainer}>
            {quiz.questions.map((q, idx) => {
              return (
                <QuestionCard
                  key={idx}
                  id={idx}
                  quizid={gameid}
                  title={q.name}
                  quiz={quiz}
                  question={q}
                  delete={deleted}
                  updateDelete={setDeleted}
                  thumbnail={quiz.questions[idx].img}
                />
              );
            })}
          </div>
        </section>
      </>
    );
  }
};

export default EditGamePage;
